import * as React from "react"
import Svg, { Path } from "react-native-svg"

function HomeIconFocused(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <Path
        d="M20.719 13.12a.61.61 0 000-.868l-7.957-7.957a.612.612 0 00-.869 0l-7.956 7.957a.614.614 0 10.869.869l7.522-7.528 7.522 7.528a.613.613 0 00.869 0z"
        fill={props?.color ?? "#2D57D9"}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.829 3.528a1.298 1.298 0 011.42.283v.001l7.953 7.953a1.298 1.298 0 01-.419 2.123 1.298 1.298 0 01-1.419-.283l-.001-.001-7.035-7.041-7.037 7.042a1.3 1.3 0 11-1.839-1.838l7.954-7.955h.002c.12-.122.263-.218.42-.284z"
        fill={props?.color ?? "#2D57D9"}
      />
      <Path
        d="M7.186 13.898c0-.227.09-.445.25-.606l4.31-4.31a.857.857 0 011.188-.023l4.69 4.33c.176.162.276.39.276.63v5.195a.857.857 0 01-.857.858h-9a.857.857 0 01-.857-.858v-5.216z"
        fill="#CCDFFF"
      />
    </Svg>
  )
}

export default HomeIconFocused
